/* unplugin-vue-components disabled */import { render } from "./MainPage.vue?vue&type=template&id=07f863d6&scoped=true"
import script from "./MainPage.vue?vue&type=script&lang=js"
export * from "./MainPage.vue?vue&type=script&lang=js"

import "./MainPage.vue?vue&type=style&index=0&id=07f863d6&scoped=true&lang=css"

import exportComponent from "D:\\project\\zjsl_project\\garden-h5-car\\garden-car\\node_modules\\.pnpm\\vue-loader@17.0.1_vue@3.2.47+webpack@5.75.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07f863d6"]])

export default __exports__